// extracted by mini-css-extract-plugin
export default {"map-frame":"Nav_kochquartier_map-frame__Yr0IC","map":"Nav_kochquartier_map__ltP41"};